<template>
    <div class="sw-column"
         :id="'sw-' + component.component + '-' + id"
         @click="$emit('select', component)">
<!--        <div v-if="edit" class="absolute h-full w-full z-10"></div>-->
        <JetLabel v-if="component.attributes.label" class="sw-mb-1 sw-mt-1" :value="component.attributes.label"></JetLabel>
        <textarea v-bind="component.attributes"
                  :required="requiredInput"
                  @change="$emit('updateContact', {id: component.id, value: $event.target.value})"
                  :rows="rowsNumber"
                  class="sw-input" />
    </div>

</template>

<script>
import JetLabel from '@/Jetstream/Label.vue'
export default {
    components:{
        JetLabel
    },
    props: {
        edit: Boolean,
        id: String,
        component: {
            type: Object,
            required: true,
        }
    },
    computed: {
        requiredInput: {
            get(){
                return this.component.attributes.required === '1' || this.component.attributes.required === true;
            },
            set(value) {
                this.component.attributes.required = value;
            }
        },
        rowsNumber() {
            const rows = this.component.attributes.rows;
            return Number.isInteger(rows) ? rows : parseInt(rows) || 4;
        }
    }
}
</script>

<style scoped lang="sass">
</style>
